import React from 'react';
import { browserHistory, Link } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { needsAuth } from './utils/authHoc';
import { Translate, I18n } from 'react-redux-i18n';
import TranslatedText from '../i18n/TranslatedText';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import CircleProgressBar from './utils/CircleProgressBar';
import ContactModal from './static/ContactModal';

import { getPlatformCourses as actionGetCourses } from '../actions/courses';
import {
  trackYandexGoal,
  addStatus as actionAddStatus,
  hasCourseAccess,
} from '../actions/utils';
import { getTrial as actionGetTrial } from '../actions/user';

import request from 'superagent';

import './SelectCourse.scss';
import './select-course-rts.scss';
import scratchLogo from '../assets/images/scratch-logo.svg';
import tinkercadLogo from '../assets/images/tinkercad.png';

import { moment } from '@utils/date';
import ConfirmParentBanner from './main/ConfirmParentBanner';

import StudentRating from '@ui/StudentRating';
import { getTinkercadLessonCourses } from '../data/tinkercad-course';

const toRomanNumeral = num => {
  const ones = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  const tens = ['', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'];
  const hundreds = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM'];

  if (num <= 0) return '';
  if (num >= 4000) return String(num);

  return (
    hundreds[Math.floor(num / 100) % 10] +
    tens[Math.floor(num / 10) % 10] +
    ones[num % 10]
  );
};

const PLATFORMS = [
  {
    name: 'snap',
  },
  {
    name: 'code',
  },
  {
    name: 'tinkercad',
    noSandbox: true,
  },
  {
    name: 'ml',
    hide: true,
  },
  {
    name: 'scratch',
    direct: '/i/gui/scratch',
    hide: true,
  },
  {
    name: 'plain',
    hide: true,
  },
];

const platformHasSandbox = name => {
  const platform = PLATFORMS.find(p => p.name === name);
  return (
    !!platform &&
    !platform.hide &&
    !platform.direct &&
    !platform.noSandbox &&
    name !== 'plain'
  );
};

const QUALITIES = ['wood', 'iron', 'diamond'];
const MAX_DIFFICULTY = 10;

class Sandbox extends React.Component {
  handleClick = () => {
    const { type, isTrialAvailable, isSubscribed, getTrial } = this.props;
    if (isTrialAvailable && !isSubscribed) {
      getTrial(`/i/gui/${type}`);
    } else {
      browserHistory.push(`/i/gui/${type}`);
    }
  };

  render() {
    const { type, isTrialAvailable, isSubscribed } = this.props;
    return (
      <div className={`card card-${type}`}>
        <div className="header">
          <div className="name-wrapper">
            <div className="name-container">
              <div className="name">
                <Translate value="greeting.sandbox.name" />
              </div>
            </div>

            <div className="platform">
              <Translate
                className="platform-name"
                value={`greeting.${type}.name`}
              />
            </div>
          </div>
          <img
            className="game-icon"
            src={require(`../assets/images/icons/pickaxe-${type}.png`)}
            alt="wood sword level"
          />
        </div>

        <p className="body">
          <Translate className="description" value="greeting.sandbox.desc" />
          <span className="misc">&nbsp;</span>
        </p>

        <div className="footer">
          <button
            className="btn btn-dark-green btn-small center-block text-uppercase"
            onClick={this.handleClick}
          >
            {isSubscribed ? (
              <Translate className="platform" value="greeting.start" />
            ) : isTrialAvailable ? (
              <Translate className="platform" value="greeting.trial" />
            ) : (
              <Translate className="platform" value="greeting.buy" />
            )}
          </button>
        </div>
      </div>
    );
  }
}

class TeacherCard extends React.PureComponent {
  state = {
    nextLesson: null,
    lessonStatus: '',
    nextLessonId: '',
    teacherRealName: '',
    teacherZoom: '',
    teacherEmail: '',
    meetLink: '',
    contactModalShown: false,
    isActiveLesson: false,
  };

  componentWillMount() {
    this.fetchData();
  }

  fetchData = () => {
    request.post('/lesson/next').end((err, res) => {
      if (!err) {
        this.setState({
          nextLesson: res.body.lesson.start,
          lessonStatus: res.body.lesson.status,
          nextLessonId: res.body.lesson._id,
          teacherEmail: res.body.lesson.teacher,
          teacherRealName: res.body.lesson.teacherRealName,
          teacherZoom: res.body.lesson.zoom,
          meetLink: res.body.lesson.meetLink,
          isActiveLesson: res.body.isActiveLesson,
        });
      }
    });
  };

  setContactModalShow = shown => {
    if (shown) {
      trackYandexGoal('apply-for-classes');
    }
    this.setState({ contactModalShown: shown });
  };

  onCancelLesson = () => {
    const res = window.confirm(I18n.t('greeting.teacher.cancelLessonMessage'));
    if (res) {
      request
        .post('/lesson/cancel')
        .send({ lessonId: this.state.nextLessonId })
        .end();
      this.fetchData();
    }
  };

  render() {
    const { user } = this.props;
    const {
      nextLesson,
      lessonStatus,
      contactModalShown,
      teacherRealName,
      teacherZoom,
      meetLink,
      isActiveLesson,
    } = this.state;

    const withTeacher =
      (user.subs.plan && !user.subs.plan.startsWith('on-your-own')) ||
      user.subs.lessons > 0;

    return (
      <div className="card">
        <div className="header withTeacher">
          <div className="name-wrapper">
            <div className="name-container">
              <div className="name">
                <Translate value="greeting.teacher.name" dangerousHTML />
              </div>
            </div>
          </div>
          <StudentRating rating={user.studentRating} />
        </div>

        <div className="body">
          {withTeacher ? (
            <React.Fragment>
              <div className="lesson-info">
                <div className="lesson-info__next-lesson">
                  {isActiveLesson ? (
                    <Translate value="greeting.teacher.current" />
                  ) : (
                    <Translate value="greeting.teacher.next" />
                  )}
                  : &nbsp;
                  <b>
                    {nextLesson ? (
                      <span
                        className={
                          lessonStatus === 'CANCELED'
                            ? 'lesson-info__next-lesson__date_canceled'
                            : ''
                        }
                      >
                        {moment(nextLesson)
                          .locale(user.language ? user.language : 'ru')
                          .format('lll')}
                      </span>
                    ) : (
                      <Translate value="greeting.teacher.nolesson" />
                    )}
                  </b>
                </div>
                {!isActiveLesson && (
                  <div className="lesson-info__description">
                    <Translate
                      className="text-muted description__info"
                      value="greeting.teacher.writeToTeacher"
                    />
                  </div>
                )}

                <div className="lesson-info__lesson-cancel">
                  {nextLesson &&
                    lessonStatus === 'SCHEDULED' &&
                    !isActiveLesson && (
                      <button
                        className="text-primary lesson-cancel"
                        onClick={this.onCancelLesson}
                      >
                        <Translate value="greeting.teacher.cancelLesson" />
                      </button>
                    )}
                </div>
              </div>

              <div className="teacher-info">
                <div className="teacher-info__name">
                  {teacherRealName && (
                    <React.Fragment>
                      <Translate value="greeting.teacher.teacher" />
                      <b>{teacherRealName}</b>
                    </React.Fragment>
                  )}
                </div>

                <div className="teacher-info__socia">
                  {teacherZoom && (
                    <a
                      href={teacherZoom}
                      className="teacher-social-button"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Zoom
                    </a>
                  )}
                  {meetLink && (
                    <a
                      href={meetLink}
                      className="teacher-social-button"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Translate value="greeting.connect" />
                    </a>
                  )}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <Translate className="description" value="greeting.teacher.free" />
          )}

          {withTeacher ? (
            <span className="miscq">&nbsp;</span>
          ) : (
            <img
              className="girl-icon"
              src={require(`../assets/images/guide-girl.png`)}
              alt="guide girl"
            />
          )}
        </div>

        <div className="footer" style={{ margin: 0 }}>
          {withTeacher ? (
            <div className="footer__lessons">
              <div className="footer__lessons-history">
                <Link
                  className="btn btn-link lesson-history__button"
                  to="/i/lessons-history"
                >
                  <Translate value="greeting.teacher.history" />
                </Link>
              </div>

              <div className="footer__lessons-balance">
                <button className="btn btn-dark-green btn-small text-uppercase footer__lessons-balance__button">
                  <Link to="/i/plan" className="lessons-on-balance">
                    <Translate
                      value="greeting.teacher.lessonsOnBalance"
                      lessons={user.subs.lessons}
                      dangerousHTML
                    />
                  </Link>
                </button>
              </div>
            </div>
          ) : (
            Boolean(user.email) && (
              <button
                className="btn btn-orange btn-small center-block text-uppercase"
                onClick={() => {
                  trackYandexGoal('apply-for-classes');
                  window.open('https://www.rts.school/', '_blank');
                }}
              >
                <Translate value="greeting.teacher.contact" />
              </button>
            )
          )}
        </div>

        <ContactModal
          show={contactModalShown}
          close={() => this.setContactModalShow(false)}
          key="/i"
          theme="Карточка: записаться на занятие"
        />
      </div>
    );
  }
}

class Course extends React.PureComponent {
  handleClick = () => {
    const {
      course,
      isSubscribed,
      isTrialAvailable,
      getTrial,
      addStatus,
    } = this.props;

    const courseUrl =
      course.type === 'tinkercad' && course.lessonId
        ? `/i/tinkercad/lesson/${course.lessonId}`
        : `/i/${course.type}/${course._id}`;

    if (isSubscribed || course.tier === 0) {
      if (!course.isAvailable) {
        addStatus(
          <Translate
            className="platform"
            value="greeting.errors.notavailable"
          />
        );
      } else {
        browserHistory.push(courseUrl);
      }
    } else {
      if (isTrialAvailable) {
        getTrial(courseUrl);
      } else {
        addStatus(
          <Translate
            className="platform"
            value="greeting.errors.subsrequired"
          />,
          false
        );
        browserHistory.replace('/i/plan');
      }
    }
  };

  render() {
    const {
      course,
      isTrialAvailable,
      isSubscribed,
      position,
      total,
      platform,
    } = this.props;

    const {
      name,
      description,
      type,
      completition = '',
      homeworks,
      isAvailable,
      image,
    } = course;

    const isTinkercad = type === 'tinkercad';

    const icon =
      isSubscribed || course.tier === 0
        ? isAvailable
          ? 'available'
          : 'not-available'
        : 'not-subscribed';

    const buttonClass = !isSubscribed || isAvailable ? 'dark-green' : 'gray';
    const hasHomeworks = homeworks && homeworks.length > 0;

    //TODO: in future this data must be provided through mongo and edited in the course editor
    const group = Math.floor(position / Math.ceil(total / QUALITIES.length));
    let quality = QUALITIES[group];
    let difficulty = (group + 1) * 2;

    if (hasHomeworks) {
      quality = QUALITIES[QUALITIES.length - 1];
      difficulty += 3;
    }
    difficulty = difficulty % MAX_DIFFICULTY;

    const gameIconSrc = isTinkercad
      ? image || tinkercadLogo
      : require(`../assets/images/icons/sword-${quality}.png`);

    return (
      <div className={`card card-${type}`}>
        {/* hasHomeworks && !isSchool && (
          <div className="card-badge">
            <Translate value="greeting.badges.teacher" />
          </div>
        ) */}

        <div className="header">
          <div className="name-wrapper">
            <div className="name-container">
              {platform !== 'all' && (
                <div className="name-order">
                  {toRomanNumeral(position + 1)}
                  .&nbsp;
                </div>
              )}
              <div className="name">
                <TranslatedText text={name} />
              </div>
            </div>

            <div className="platform">
              <Translate
                className="platform-name"
                value={`greeting.${type}.name`}
              />
            </div>
          </div>

          <img
            className={`game-icon${isTinkercad ? ' game-icon--tinkercad' : ''}`}
            src={gameIconSrc}
            alt={isTinkercad ? 'Tinkercad lesson' : 'course level'}
          />
        </div>

        <p className="body">
          <TranslatedText className="description" text={description} />
          {!isTinkercad && (
            <span className="misc">
              <Translate value="greeting.difficulty" /> : {difficulty}/
              {MAX_DIFFICULTY}
            </span>
          )}
        </p>

        <div className="footer">
          {course.type !== 'plain' && (
            <React.Fragment>
              <img
                src={require(`../assets/images/icons/course-${icon}.png`)}
                className="status-icon"
                alt={icon}
              />

              {!isTinkercad && (
                <CircleProgressBar
                  percentage={completition}
                  startColor="#ffc129"
                  endColor="#99c93e"
                  gradientId={`progress_${course._id}`}
                />
              )}
            </React.Fragment>
          )}

          <button
            className={`btn btn-${buttonClass} btn-small text-uppercase`}
            onClick={this.handleClick}
          >
            {isSubscribed || course.tier === 0 ? (
              <Translate className="platform" value="greeting.start" />
            ) : isTrialAvailable ? (
              <Translate className="platform" value="greeting.trial" />
            ) : (
              <Translate className="platform" value="greeting.buy" />
            )}
          </button>
        </div>
      </div>
    );
  }
}

// Refactoring please
const Courses = ({ user, courses, platform, ...props }) => (
  <Row className="course-cards">
    {courses.map((c, i) => (
      <Course
        key={`course_${c._id}`}
        course={c}
        position={i}
        total={courses.length}
        platform={platform}
        {...props}
      />
    ))}
    {platform !== 'all' ? (
      platformHasSandbox(platform) ? (
        <Sandbox type={platform} {...props} />
      ) : null
    ) : (
      PLATFORMS.filter(p => platformHasSandbox(p.name)).map(p => (
        <Sandbox type={p.name} key={`sandbox_${p.name}_all`} {...props} />
      ))
    )}
  </Row>
);

const PlatformLink = ({ p, link, isActive, rtsBasePath }) => (
  <Link
    to={link || (rtsBasePath ? `${rtsBasePath}/${p}` : `/i/${p}`)}
    className={`list-group-item ${isActive ? 'active' : ''} platform-item`}
  >
    {p === 'plain' && (
      <div className="platform-item-other">
        <Translate value="greeting.plain.header" />
      </div>
    )}
    {p !== 'plain' && (
      <img
        className="platform-logo center-block"
        src={
          p === 'scratch'
            ? scratchLogo
            : p === 'tinkercad'
              ? tinkercadLogo
              : require(`../assets/images/${p === 'code' ? 'python' : p}.png`)
        }
        alt={`${p} logo`}
      />
    )}
  </Link>
);

const getPlatformLogo = p => {
  if (p === 'scratch') return scratchLogo;
  if (p === 'tinkercad') return tinkercadLogo;
  return require(`../assets/images/${p === 'code' ? 'python' : p}.png`);
};

const RtsPlatformSidebar = ({ platform, allCoursesPath }) => (
  <aside
    className="rts-sidebar"
    aria-label={I18n.t('greeting.courses.available')}
  >
    <div className="rts-sidebar__inner">
      <div className="rts-sidebar__title">
        <Translate value="greeting.courses.available" />
      </div>

      <nav className="rts-sidebar__nav">
        <Link
          to={allCoursesPath}
          className={`rts-sidebar__item rts-sidebar__item--all${
            platform === 'all' ? ' rts-sidebar__item--active' : ''
          }`}
        >
          <span className="rts-sidebar__item-label">
            <Translate value="greeting.all.header" />
          </span>
        </Link>

        {PLATFORMS.filter(p => !p.hide).map(p => {
          const to =
            p.direct || (p.name === 'all' ? allCoursesPath : `/i/${p.name}`);
          const isActive = p.name === platform;
          const isLogoOnly = p.name !== 'plain';

          return (
            <Link
              key={p.name}
              to={to}
              className={`rts-sidebar__item${
                isLogoOnly ? ` rts-sidebar__item--logo-only rts-sidebar__item--${p.name}` : ''
              }${isActive ? ' rts-sidebar__item--active' : ''}`}
              aria-label={
                isLogoOnly ? I18n.t(`greeting.${p.name}.name`) : undefined
              }
            >
              {isLogoOnly ? (
                <img
                  src={getPlatformLogo(p.name)}
                  alt={I18n.t(`greeting.${p.name}.name`)}
                  className="rts-sidebar__item-logo"
                />
              ) : (
                <span className="rts-sidebar__item-label">
                  <Translate value="greeting.plain.header" />
                </span>
              )}
            </Link>
          );
        })}
      </nav>
    </div>
  </aside>
);

class SelectCourse extends React.Component {
  state = {
    showContactModal: false,
  };

  _isMounted = false;

  checkPlatform = () => {
    if (!this._isMounted) return;
    const { platform, getCourses, user, design } = this.props;
    const selectedPlatform =
      platform && PLATFORMS.find(p => p.name === platform);

    if (!selectedPlatform && platform !== 'all') {
      browserHistory.push(design === 'rts' ? '/i/all' : '/i/snap');
    } else if (user) {
      if (platform !== 'tinkercad') {
        getCourses(platform);
      }
      localStorage.setItem('lastPlatform', platform);
    }
  };

  componentDidMount() {
    this._isMounted = true;
    this.checkPlatform();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillReceiveProps(newProps) {
    const { platform, getCourses, user } = newProps;
    if (!this._isMounted || !user) return;
    if (this.props.platform !== platform && platform !== 'tinkercad') {
      getCourses(platform);
    }
  }

  toggleContactModal = () => {
    if (!this.state.showContactModal) trackYandexGoal('apply-for-classes');
    this.setState({ showContactModal: !this.state.showContactModal });
  };

  render() {
    const {
      platform,
      courses = [],
      user,
      addStatus,
      getTrial,
      isTrialAvailable,
      isSubscribed,
      design = 'legacy',
    } = this.props;

    const allCoursesPath = design === 'rts' ? '/i/all' : '/i/all-old';

    let filteredCourses = courses.filter(c => c.visible);
    let isLoaded;

    if (platform === 'tinkercad') {
      isLoaded = filteredCourses.length > 0;
    } else if (platform !== 'all') {
      isLoaded = filteredCourses.every(c => c.type === platform);
    } else {
      //isLoaded = PLATFORMS.every(p => filteredCourses.some(c => c.type === p || PLATFORMS_HIDE.includes(c.type)));
      isLoaded = filteredCourses.length > 0;
      filteredCourses = filteredCourses.filter(c => {
        const p = PLATFORMS.find(p => p.name === c.type);
        return !p.hide && !p.direct;
      });
    }

    if (filteredCourses.length === 0) isLoaded = false;

    if (!isLoaded) filteredCourses = [];

    const isRts = design === 'rts';

    const courseContent = (
      <React.Fragment>
        <ConfirmParentBanner />
        <Row className={`select-course-header ${platform}`}>
          <h1>
            <Translate value={`greeting.${platform}.header`} />
            <span className="course-count">
              {filteredCourses.length > 0 ? (
                filteredCourses.length
              ) : (
                <span>&nbsp;&nbsp;</span>
              )}
            </span>
          </h1>

          <p>
            <Translate value={`greeting.${platform}.description`} />
          </p>
        </Row>

        {isLoaded && (
          <Courses
            user={user}
            courses={filteredCourses}
            platform={platform}
            addStatus={addStatus}
            isSchool={!!user.school}
            isTrialAvailable={isTrialAvailable}
            isSubscribed={isSubscribed}
            getTrial={getTrial}
          />
        )}
      </React.Fragment>
    );

    if (isRts) {
      return (
        <div className="full-page select-course-page select-course-page--rts">
          <aside className="rts-sidebar-col hidden-xs">
            <RtsPlatformSidebar
              platform={platform}
              allCoursesPath={allCoursesPath}
            />
          </aside>
          <section className="select-course">{courseContent}</section>
        </div>
      );
    }

    return (
      <Row className="row row-flex full-page select-course-page">
        <Col sm={3} lg={2} className="select-platform hidden-xs">
          <div className="affix">
            <Row className="platform-header text-uppercase">
              <Translate value="greeting.courses.available" />
            </Row>

            <Row className="list-group platform-selector">
              <Link
                to={allCoursesPath}
                className="platform-item platform-all"
              >
                <Translate value="greeting.all.header" />
              </Link>

              {PLATFORMS.filter(p => !p.hide).map(p => (
                <PlatformLink
                  key={`platform_${p.name}`}
                  p={p.name}
                  link={p.direct}
                  isActive={p.name === platform}
                />
              ))}
              <Link
                to={'/i/chatgpt'}
                className={`list-group-item platform-item projects-item hidden-all-nav-item`}
              >
                ChatGPT
              </Link>

              <Link
                to={'/i/invite'}
                className={`list-group-item platform-item invite-item hidden-all-nav-item`}
              >
                {`🎁 ${I18n.t('invitation.inviteTitle')} `}
              </Link>

              <Link
                to={'/i/projects'}
                className={`list-group-item platform-item projects-item hidden-all-nav-item`}
              >
                {I18n.t('nav.projects')}
              </Link>
            </Row>
          </div>
        </Col>
        <Col xs={12} sm={9} lg={10} className="select-course">
          {courseContent}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { items: courses } = state.courses;
  const { user } = state.auth;
  const { locale: lang } = state.i18n;
  const {
    params: { platform },
    forcedPlatform,
  } = ownProps;

  let correctedPlatform =
    forcedPlatform || platform || localStorage.getItem('lastPlatform');
  let filteredCourses =
    correctedPlatform === 'tinkercad'
      ? getTinkercadLessonCourses()
      : courses
          .filter(c => c.langs.includes(lang))
          .sort((a, b) =>
            a.priority && a.priority > b.priority
              ? 1
              : b.priority > a.priority
              ? -1
              : 0
          );

  const isSubscribed = user && hasCourseAccess(user);
  const isTrialAvailable =
    user && !isSubscribed && user.subs && !user.subs.trial;

  return {
    courses: filteredCourses,
    user,
    isTrialAvailable,
    isSubscribed,
    platform: correctedPlatform,
  };
};

const mapDispatchToProps = dispatch => ({
  getCourses: platform => dispatch(actionGetCourses(platform)),
  addStatus: (err, close = true) => dispatch(actionAddStatus(err, close)),
  getTrial: redirect => dispatch(actionGetTrial(redirect)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  needsAuth
)(SelectCourse);
